const types = {
  DUMMY_ACTION: 'DUMMY_ACTION',
  FETCH_ALL_TODOS: 'FETCH_ALL_TODOS',
  FAIL_ALL_TODOS: 'FAIL_ALL_TODOS',
  SUCCESS_ALL_TODOS: 'SUCCESS_ALL_TODOS',
  SET_FILTER: 'SET_FILTER',
  ADD_TODO: 'ADD_TODO',
  SUCCESS_ADD_TODO: 'SUCCESS_ADD_TODO',
  FAIL_ADD_TODO: 'FAIL_ADD_TODO',
  SET_DELETING_TODO_ID: 'SET_DELETING_TODO_ID',
  DELETE_TODO: ' DELETE_TODO',
  SUCCESS_DELETE_TODO: ' SUCCESS_DELETE_TODO',
  FAIL_DELETE_TODO: ' FAIL_DELETE_TODO',
  TOGGLE_TODO: 'TOGGLE_TODO',
  SUCCESS_TOGGLE_TODO: 'SUCCESS_TOGGLE_TODO',
  FAIL_TOGGLE_TODO: 'FAIL_TOGGLE_TODO',
  UPDATE_TODO: 'UPDATE_TODO',
  SUCCESS_UPDATE_TODO: 'SUCCESS_UPDATE_TODO',
  FAIL_UPDATE_TODO: 'FAIL_UPDATE_TODO',
  SET_TEMPLATE_MODE: 'SET_TEMPLATE_MODE',
};

export default types;
